var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u89C6\u9891") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "065-\\u661F\\u90142.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A2-\\u8F66\\u8F86\\u76D1\\u63A7-\\u5B9E\\u65F6\\u76D1\\u63A7-\\u62A5\\u8B66\\u4FE1\\u606F",
    transform: "translate(-1784.000000, -141.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F39\\u7A971",
    transform: "translate(800.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9AD8\\u62A5\\u8B66\\u6D88\\u606F",
    transform: "translate(20.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(904.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.2,5.5 L82.4700011,3.45624934 C82.9383376,3.16353901 83.555288,3.30591217 83.8479983,3.7742487 C83.9473306,3.9331803 84,4.11682792 84,4.30424764 L84,15.6957524 C84,16.2480371 83.5522847,16.6957524 83,16.6957524 C82.8125803,16.6957524 82.6289327,16.6430829 82.4700011,16.5437507 L79.2,14.5 L79.2,14.5 L79.2,17 C79.2,18.1045695 78.3045695,19 77.2,19 L62,19 C60.8954305,19 60,18.1045695 60,17 L60,3 C60,1.8954305 60.8954305,1 62,1 L77.2,1 C78.3045695,1 79.2,1.8954305 79.2,3 L79.2,5.5 L79.2,5.5 Z M67.75,6.77491925 L67.75,13.2250807 C67.7504827,13.4187444 67.8593039,13.5964953 68.0332942,13.6878196 C68.2072846,13.7791439 68.4183192,13.7692793 68.5826804,13.6621391 L73.5112485,10.4378473 C73.6604059,10.3402568 73.75,10.1759499 73.75,10 C73.75,9.82405014 73.6604059,9.65974323 73.5112485,9.56215269 L68.5826804,6.33786085 C68.4183192,6.23072072 68.2072846,6.22085613 68.0332942,6.31218039 C67.8593039,6.40350466 67.7504827,6.58125565 67.75,6.77491925 Z",
    id: "\\u89C6\\u9891"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/视频.95d6b64d1d9f44cf5e12ba7315352838.svg";
export { ForwardRef as ReactComponent };